import React from "react";
import { useTenantsApp } from "../../Context/TenantsApp/TenantsAppContext";
import { SET_ERROR } from "./TenantsAppEvents"
import { useTranslation } from "react-i18next";

const AppInvalidBanner = () => {
    const { state, dispatch } = useTenantsApp();
    const { t } = useTranslation("tenant/tenant", { useSuspense: false });

    const { isActive, hasSchemaChanges } = state.project;
    const showSchemaAlert = !isActive || hasSchemaChanges;
    const showErrorAlert = Boolean(state.errorMessage);

    if (!showSchemaAlert && !showErrorAlert) {
        return null;
    }

    const clearError = () =>
        dispatch({ type: SET_ERROR, payload: null });

    return (
        <div className="app-invalid-banner mb-3">
            {showSchemaAlert && (
                <div className="alert alert-warning d-flex align-items-start">
                    <i className="fas fa-exclamation-triangle me-2 mt-1"></i>
                    <div>
                        <strong>{t("schema_update")}</strong>{" "}
                        <span className="text-muted">
                            {t("schema_update_message")}
                        </span>
                    </div>
                </div>
            )}

            {showErrorAlert && (
                <div className="alert alert-danger d-flex align-items-center justify-content-between">
                    <div>
                        <i className="fas fa-exclamation-circle me-2"></i>
                        {state.errorMessage}
                    </div>
                    <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={clearError}
                    />
                </div>
            )}
        </div>
    );
};

export default AppInvalidBanner;
